module.exports = __webpack_public_path__ + "files/60b86f79c18e1fdf64073ce34dbc5903.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icons/video.png
 ** module id = 386
 ** module chunks = 0
 **/